export default "__VITE_ASSET__5cdb0173__"